import { useState } from 'react';
import { ProjectsListScreen } from './reports/ProjectsListScreen';
import { ProjectTimelineView } from './reports/ProjectTimelineView';
import type { Category, Task, TaskSubmission } from '../../App';
import type { Project } from '../../types/project';
import type { PINCode } from './VendorsScreen';
import type { MicrosoftAccount, SupervisorAccess } from './PINCodesScreen';

interface ReportsScreenProps {
  categories?: Category[];
  tasks?: Task[];
  projects?: Project[];
  submissions?: TaskSubmission[];
  pinCodes?: PINCode[];
  supervisorAccess?: SupervisorAccess | null;
  microsoftAccounts?: MicrosoftAccount[];
  onAddProject?: (project: Project) => void;
  onUpdateProject?: (project: Project) => void;
  onDeleteProject?: (projectId: string) => void;
  onNavigateToManageAccess?: () => void;
}

export function ReportsScreen({
  categories = [],
  tasks = [],
  projects = [],
  submissions = [],
  pinCodes = [],
  supervisorAccess = null,
  microsoftAccounts = [],
  onAddProject,
  onUpdateProject,
  onDeleteProject,
  onNavigateToManageAccess,
}: ReportsScreenProps) {
  const [selectedProjectId, setSelectedProjectId] = useState<string | null>(null);

  const handleUpdateProject = (updatedProject: Project) => {
    onUpdateProject?.(updatedProject);
  };

  const handleDeleteProject = (projectId: string) => {
    onDeleteProject?.(projectId);
    if (selectedProjectId === projectId) setSelectedProjectId(null);
  };

  if (selectedProjectId) {
    const project = projects.find(p => p.id === selectedProjectId);
    if (!project) {
      setSelectedProjectId(null);
      return null;
    }
    return (
      <ProjectTimelineView
        project={project}
        submissions={submissions}
        categories={categories}
        onBack={() => setSelectedProjectId(null)}
        onUpdateProject={handleUpdateProject}
      />
    );
  }

  return (
    <ProjectsListScreen
      onSelectProject={setSelectedProjectId}
      categories={categories}
      allTasks={tasks}
      projects={projects}
      pinCodes={pinCodes}
      supervisorAccess={supervisorAccess}
      microsoftAccounts={microsoftAccounts}
      onAddProject={onAddProject || (() => {})}
      onUpdateProject={onUpdateProject || (() => {})}
      onDeleteProject={handleDeleteProject}
      onNavigateToManageAccess={onNavigateToManageAccess}
    />
  );
}
